let currentRating = 0;

function openReviewModal() {
  document.getElementById('reviewModal').style.display = 'flex';
  document.body.style.overflow = 'hidden';
  
  const stickyButton = document.getElementById('stickyReviewButton');
  if (stickyButton) {
    stickyButton.style.display = 'none';
  }
}

function closeReviewModal() {
  document.getElementById('reviewModal').style.display = 'none';
  document.body.style.overflow = 'auto';
  
  if (localStorage.getItem('hideStickyReviewButton') !== 'true') {
    const stickyButton = document.getElementById('stickyReviewButton');
    if (stickyButton) {
      stickyButton.style.display = 'flex';
    }
  }

  document.querySelector('#reviewModal .loader').style.display = 'none';
  document.querySelector('#reviewModal .submit-btn').style.display = 'block';
}

function openGalleryModal() {
  document.getElementById('galleryModal').style.display = 'flex';
  document.body.style.overflow = 'hidden';
}

function closeGalleryModal() {
  document.getElementById('galleryModal').style.display = 'none';
  document.body.style.overflow = 'auto';
}

function hideStickyButton() {
  const stickyButton = document.getElementById('stickyReviewButton');
  if (stickyButton) {
    stickyButton.style.display = 'none';
    localStorage.setItem('hideStickyReviewButton', 'true');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  if (localStorage.getItem('hideStickyReviewButton') === 'true') {
    const stickyButton = document.getElementById('stickyReviewButton');
    if (stickyButton) {
      stickyButton.style.display = 'none';
    }
  }
  
  const reviewModal = document.getElementById('reviewModal');
  if (reviewModal) {
    reviewModal.addEventListener('click', function(e) {
      if (e.target === this) {
        closeReviewModal();
      }
    });
  }
  
  const galleryModal = document.getElementById('galleryModal');
  if (galleryModal) {
    galleryModal.addEventListener('click', function(e) {
      if (e.target === this) {
        closeGalleryModal();
      }
    });
  }

  // Form submission code
  const testimonialForm = document.getElementById('testimonialForm');
  if (testimonialForm) {
    testimonialForm.addEventListener('submit', async function(e) {
      e.preventDefault();

      const form = e.target;
      const formData = new FormData(form);

      const rate = parseInt(form.querySelector('#ratingInput').value, 10);

      if (!rate || rate < 1) {
        alert("Please specify Star Rating");
        return;
      }
      
      // Extract the custom_images[] files before removing them
      const customImageFiles = form.querySelector('input[name="custom_images[]"]').files;

      // Remove all entries with key "custom_images[]"
      for (let pair of [...formData.entries()]) {
        if (pair[0] === 'custom_images[]') {
          formData.delete(pair[0]);
        }
      }

      document.querySelector('#reviewModal .loader').style.display = 'block';
      document.querySelector('#reviewModal .submit-btn').style.display = 'none';
      
      try {
        // Step 1: Submit the testimonial (basic data + optional main image)
        const response = await fetch('https://apps.gemstonesforsale.com/wp-json/gemstone-sale/v1/testimonial', {
          method: 'POST',
          body: formData
        });

        const result = await response.json();

        if (result.error) {
          alert("Error: " + result.error);
          return;
        }

        const testimonialId = result.testimonial_id;

        if (!testimonialId) {
          alert("Error: Testimonial ID missing from response.");
          return;
        }

        // Step 2: Submit the custom_images[] (gallery) if any
        if (customImageFiles.length > 0) {
          const imageFormData = new FormData();
          imageFormData.append('testimonial_id', testimonialId);

          for (let file of customImageFiles) {
            imageFormData.append('custom_images[]', file);
          }

          const imageResponse = await fetch('https://apps.gemstonesforsale.com/wp-json/gemstone-sale/v1/testimonial-images', {
            method: 'POST',
            body: imageFormData
          });

          const imageResult = await imageResponse.json();

          if (imageResult.error) {
            alert("Images upload error: " + imageResult.error);
            return;
          }
        }

        alert("Review submitted successfully!");
        // Reset the form after successful submission
        testimonialForm.reset();
        closeReviewModal();

      } catch (error) {
        console.error('Submission failed:', error);
        alert('Something went wrong. Please try again.');
      }
    });
  }

  // File upload functionality
  document.getElementById("upload-image-area").addEventListener("click", () => {
    document.getElementById("photos").click()
  })

   // restrict to 3 images
  const fileInput = document.getElementById("photos")
  const errorMsg = document.getElementById("file-error")
  if (fileInput) {
    fileInput.addEventListener("change", () => {
      if (fileInput.files.length > 3) {
        errorMsg.style.display = "block"
        fileInput.value = "" // clear the selection
      } else {
        errorMsg.style.display = "none"
      }
      if (fileInput.files.length > 0 && fileInput.files.length <= 3) {
        document.getElementById("choose-photos-btn").innerHTML = fileInput.files.length + " Files Selected"
      } else {
        document.getElementById("choose-photos-btn").innerHTML = "Choose Photos"
      }
    })
  }
});

let currentPage = 1;
let totalPages = 1;

async function loadTestimonials(page = 1) {
  try {
    const response = await fetch(`https://apps.gemstonesforsale.com/wp-json/gemstone-sale/v1/get-testimonials?page=${page}`);
    const data = await response.json();
    console.log(data);

    const testimonials = data.testimonials;
    const container = document.getElementById('reviewsList');
    const instagramContainer = document.getElementById('instagramTestimonialContainer');
    const showMoreButton = document.getElementById('showMoreTestimonialsBtn');

    let reviewCount = container.querySelectorAll('.review-card').length;
    let instagramInserted = container.contains(instagramContainer);

    Object.values(testimonials).forEach((item, index) => {
      const name = item.name || '';
      const words = name.trim().split(/\s+/);

      let initials = '?';
      if (words.length === 1) {
        initials = words[0].charAt(0).toUpperCase();
      } else if (words.length > 1) {
        initials = words[0].charAt(0).toUpperCase() + words[1].charAt(0).toUpperCase();
      }
      // star-rating
      const stars = generateStars(item.rating);
      var item_quantity = '';
      if (item.quantity) {
        item_quantity = `<div class="purchase-info">
          <span class="purchase-label">Order Qty:</span>
          <span class="purchase-value">${item.quantity}</span>
        </div>`;
      }

      // gallery-images
      let imagesHTML = "";
      if (item.gallery_images && item.gallery_images.length > 0) {
        imagesHTML = item.gallery_images.map(img => 
          `<img src="${img}" alt="Review Image" class="review-image" />`
        ).join("");
      }

      const card = `
        <div class="review-card">
          <div class="review-header">
            <div class="review-avatar">
                <div class="review-intials">${initials}</div>
            </div>
            <div class="review-content">
              <div class="review-meta">
                <div class="review-customer">
                  <div class="customer-info">
                    <h4 class="customer-name">${item.name}</h4>
                    <svg class="verified-icon" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
                    </svg>
                  </div>
                  <div class="purchase-info">
                    <span class="purchase-label">Purchase:</span>
                    <span class="purchase-value">${item.purchase}</span>
                  </div>
                  ${item_quantity}
                </div>
                <div class="review-rating-date">
                  <div class="review-stars">${stars}</div>
                  <div class="review-date">${item.created}</div>
                </div>
              </div>
              <div class="review-text">${item.review}</div>
              <div class="review-images">${imagesHTML}</div>
            </div>
          </div>
        </div>
      `;

      container.innerHTML += card;
      reviewCount++;

      // Insert Instagram container only once after 3rd review
      if (reviewCount === 3 && !instagramInserted && instagramContainer) {
        container.appendChild(instagramContainer);
        instagramContainer.style.display = 'block';
        instagramInserted = true;

        container.addEventListener('click', function (e) {
          if (e.target.classList.contains('insta-more')) {
            const text = container.querySelector('.read-more-text');
            const lessBtn = container.querySelector('.insta-less');
            e.target.style.display = 'none';
            text.style.maxHeight = text.scrollHeight + 'px';
            lessBtn.style.display = 'inline-block';
          }

          if (e.target.classList.contains('insta-less')) {
            const text = container.querySelector('.read-more-text');
            const moreBtn = container.querySelector('.insta-more');
            e.target.style.display = 'none';
            text.style.maxHeight = '0';
            moreBtn.style.display = 'inline-block';
          }
        });
      }
    });

    // Update pagination info
    totalPages = data.pagination.total_pages;
    currentPage = data.pagination.current_page;

    // Show or hide "Show More" button
    if (currentPage < totalPages) {
      showMoreButton.style.display = 'block';
    } else {
      showMoreButton.style.display = 'none';
    }

  } catch (error) {
    console.error("Failed to load Reviews:", error);
  }
}

// Initial load
document.addEventListener('DOMContentLoaded', () => {
  loadTestimonials();

  const showMoreButton = document.getElementById('showMoreTestimonialsBtn');
  if (showMoreButton) {
    showMoreButton.addEventListener('click', () => {
      if (currentPage < totalPages) {
        loadTestimonials(currentPage + 1);
      }
    });
  }
});

function generateStars(rating) {
  const filled = parseInt(rating);
  const total = 5;
  let starsHTML = '';
  for (let i = 0; i < total; i++) {
    starsHTML += `
      <svg class="review-star ${i < filled ? 'star-filled' : 'star-empty'}" fill="currentColor" viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
      </svg>`;
  }
  return starsHTML;
}

// for star rating

function initializeStarRatings() {
  // For each star container
  document.querySelectorAll('.modal-stars').forEach(container => {
    const stars = container.querySelectorAll('.rating-star');
    const hiddenInput = container.parentElement.querySelector('input[type="hidden"]');
    let currentRating = 0; // local rating per container

    function setRating(rating) {
      currentRating = rating;
      if (hiddenInput) hiddenInput.value = rating;
      updateStars(rating);
    }

    function setHoverRating(rating) {
      updateStars(rating);
    }

    function restoreRating() {
      updateStars(currentRating);
    }

    function updateStars(rating) {
      stars.forEach((star, index) => {
        star.classList.toggle('active', index < rating);
      });
    }

    // Add listeners
    stars.forEach((star, index) => {
      star.addEventListener('mouseenter', () => setHoverRating(index + 1));
      star.addEventListener('click', () => setRating(index + 1));
    });

    container.addEventListener('mouseleave', restoreRating);
  });
}

// Initialize after DOM is ready
document.addEventListener('DOMContentLoaded', initializeStarRatings);